<template>
  <div
    class="hm-cell"
    :style="cellStyle"
    :title="tooltip"
    @click="$emit('click')">
    <template v-if="metrics && !isNullMetrics">
      <div
        class="hm-cell-row"
        :class="textClass">
        <span class="hm-cell-pct">{{ metrics.allocatedProduct != null ? metrics.allocatedProduct : '—' }}</span>
        <span class="hm-cell-sep">/</span>
        <span class="hm-cell-count">{{ metrics.capacityProduct != null ? metrics.capacityProduct : '—' }}</span>
      </div>
      <!-- <div class="hm-cell-row hm-cell-pcs-row">
        <span class="hm-cell-pct">{{ metrics.allocatedPcs != null ? metrics.allocatedPcs.toLocaleString() : '—' }}</span>
        <span class="hm-cell-sep">/</span>
        <span class="hm-cell-count">{{ metrics.capacityPcs != null ? metrics.capacityPcs.toLocaleString() : '—' }} pcs</span>
      </div> -->
    </template>
    <template v-else>
      <div class="hm-cell-empty grey--text">
        —
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'HeatmapCell',
  props: {
    metrics: { type: Object, default: null },
    mode: { type: String, default: 'tentative' }
  },
  computed: {
    isNullMetrics () {
      if (!this.metrics) {
        return true
      }

      return this.metrics.allocatedProduct === null && this.metrics.capacityProduct === null
    },
    pcsUtilization () {
      if (this.isNullMetrics) return null
      return this.metrics.pcsUtilization !== undefined ? Math.round(this.metrics.pcsUtilization) : null
    },
    productUtilization () {
      if (this.isNullMetrics) return null
      return this.metrics.productUtilization !== undefined ? Math.round(this.metrics.productUtilization) : null
    },
    cellStyle () {
      const u = this.productUtilization
      if (this.isNullMetrics) return { background: '#F5F5F5', borderRadius: '6px' }
      if (u < 50) return { background: '#FFCDD2', borderRadius: '6px' }
      if (u < 70) return { background: '#FFF9C4', borderRadius: '6px' }
      if (u < 95) return { background: '#C8E6C9', borderRadius: '6px' }
      if (u <= 100) return { background: '#FFE0B2', borderRadius: '6px' }
      return { background: '#FFCDD2', borderRadius: '6px' }
    },
    textClass () {
      const u = this.productUtilization
      if (this.isNullMetrics) return 'grey--text'
      if (u < 50) return 'red--text text--darken-2'
      if (u < 70) return 'amber--text text--darken-4'
      if (u < 95) return 'green--text text--darken-2'
      if (u <= 100) return 'orange--text text--darken-2'
      return 'red--text text--darken-2'
    },
    tooltip () {
      if (this.isNullMetrics) return 'No data'
      return [
        `Product: ${this.metrics.allocatedProduct ?? '—'} / ${this.metrics.capacityProduct ?? '—'}`
        + ` (${this.productUtilization !== null ? `${this.productUtilization }%` : '—'} util)`,
        `PCS: ${this.metrics.allocatedPcs ?? '—'} / ${this.metrics.capacityPcs ?? '—'}`
        + ` (${this.pcsUtilization !== null ? `${this.pcsUtilization }%` : '—'} util)`
      ].join('\n')
    }
  }
}
</script>

<style scoped>
.hm-cell {
  height: 42px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  padding: 4px 2px;
  transition: transform 0.12s, box-shadow 0.12s;
}
.hm-cell:hover {
  transform: scale(1.06);
  box-shadow: 0 3px 10px rgba(0,0,0,0.18);
  z-index: 1;
  position: relative;
}
.hm-cell-row {
  display: flex;
  align-items: baseline;
  gap: 2px;
  line-height: 1.2;
  font-weight: 700;
}
.hm-cell-pct {
  font-size: 11px;
}
.hm-cell-sep {
  font-size: 10px;
  opacity: 0.45;
}
.hm-cell-count {
  font-size: 10px;
  opacity: 0.8;
}
.hm-cell-pcs-row {
  color: rgba(0,0,0,0.45);
  font-weight: 400;
}
.hm-cell-empty {
  font-size: 13px;
  font-weight: 600;
}
</style>
